import { IconName } from "../../../Icon";
import WelcomeRectangle1MaskSvg from "../../../../assets/images/welcome-rectangle-1-mask.svg";
import WelcomeRectangle2MaskSvg from "../../../../assets/images/welcome-rectangle-2-mask.svg";
import WelcomeRectangle3MaskSvg from "../../../../assets/images/welcome-rectangle-3-mask.svg";
import WelcomeRectangle1ShadowMaskSvg from "../../../../assets/images/welcome-rectangle-1-shadow-mask.svg";
import WelcomeRectangle2ShadowMaskSvg from "../../../../assets/images/welcome-rectangle-2-shadow-mask.svg";
import WelcomeRectangle3ShadowMaskSvg from "../../../../assets/images/welcome-rectangle-3-shadow-mask.svg";
import { StyleProp, ViewStyle } from "react-native";

export type RectangleViewProps = {
    icons?: IconName[];
    title?: string;
    description: React.ReactNode;
    style?: StyleProp<ViewStyle>;
};

const shadowMaskProps = {
    style: {
        width: 443,
        height: 275,
    },
};

export const RECTANGLE_SIZES_MAP = [
    {
        MaskComponent: WelcomeRectangle3MaskSvg,
        rectWidth: 327,
        rectHeight: 209,
        shadowMaskComponentElement: <WelcomeRectangle3ShadowMaskSvg {...shadowMaskProps} />,
        shadowWidth: 443,
        shadowHeight: 275,
    },
    {
        MaskComponent: WelcomeRectangle1MaskSvg,
        rectWidth: 321,
        rectHeight: 182,
        shadowMaskComponentElement: <WelcomeRectangle1ShadowMaskSvg {...shadowMaskProps} />,
        shadowWidth: 443,
        shadowHeight: 275,
    },
    {
        MaskComponent: WelcomeRectangle2MaskSvg,
        rectWidth: 321,
        rectHeight: 179,
        shadowMaskComponentElement: <WelcomeRectangle2ShadowMaskSvg {...shadowMaskProps} />,
        shadowWidth: 443,
        shadowHeight: 275,
    },
];
